import React from 'react';
import api from 'api';
import { Spinner, AlertMessage } from 'hyperdb-utils';
import EmailForm from './Form';

class ReplyForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleBack = this.handleBack.bind(this);
  }
  componentDidMount() {
    this.props.api.message.getData({ url: `/${this.props.params.id}/reply` })
      .then(({ message, quotedMessage }) => {
        this.props.api.message.setData({ objectData: message, quotedMessage, attachments: [] });
        /* this.props.api.message.setData({
          defined_template: !message.template_id.value[1] || message.template_id.value[1] === '0',
        });*/
      });
  }
  /* componentWillReceiveProps(nextProps) {
    if (nextProps.objectData && nextProps.submitSuccessful) {
      this.handleBack();
    }
  }*/
  componentWillUnmount() {
    this.props.api.message.leaveForm();
  }
  render() {
    if (!this.props.objectData) return <div className="box"><Spinner show={ true } /></div>;
    return (
      <div className="content-wrapper">
        <section className="content-header content-header-fixed">
          <div className="row">
            <div className="col-md-12">
              <span className="btn btn-sm btn-primary" onClick={ this.handleBack }>
                <i className="fas fa-chevron-left"></i> Back
              </span>
              &nbsp;<h3 className="box-title">Reply</h3>
            </div>
          </div>
        </section>
        <section className="content content-fixed">
          <div className="box box-primary">
            {
              this.props.successMessage
                ? <AlertMessage
                    type="success"
                    onDismiss={ this.props.api.message.dismissAlert }>
                      { this.props.successMessage }
                  </AlertMessage>
                : null
            }
            {
              this.props.errorMessage
                ? <AlertMessage
                    type="error"
                    onDismiss={ this.props.api.message.dismissAlert }>
                      { this.props.errorMessage }
                  </AlertMessage>
                : null
            }
            <Spinner show={ this.props.loading } />
            <div className="hyperdb-form">
              <EmailForm
                { ...this.props }
                updateEditedObject={ this.props.api.message.updateEditedObject }
                forReply={ true }
                showSaveButtons={ true } />
            </div>
          </div>
        </section>
      </div>
    );
  }

  handleBack() {
    if (window.previousLocation) {
      this.props.router.push(window.previousLocation);
    } else {
      this.props.api.routing.redirect(this.props.router, '/email/messages');
    }
  }
}

ReplyForm.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
  updateEditedObject: React.PropTypes.func,
  availableLanguages: React.PropTypes.array,
};

export default api.connect(ReplyForm, 'message');



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/containers/ReplyForm.jsx